exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".O9oW9{background:#fff;color:#333;font-weight:400}@media (min-width:768px){.O9oW9{-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.2);box-shadow:0 1px 4px 0 rgba(0,0,0,.2);left:0;position:fixed;right:0;top:0;z-index:999}}.qQ2mF{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap;margin:0 auto;padding:0 15px;max-width:1000px;text-align:center}._1pDKW{display:none;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-top:15px}@media (max-width:767px){._1pDKW{display:-webkit-box;display:-ms-flexbox;display:flex;position:absolute;right:15px;top:5px}._3U7Ez{display:none}}._24MvK{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin:0}.YbXHq{padding-bottom:20px;padding-top:20px;width:35%}@media (max-width:441px){.YbXHq{width:100%}}._1kxfm{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap}._3qu-v{text-decoration:none}._3Wcfe{color:#333;text-align:left;font-family:Roboto;padding-left:8px}@media (max-width:441px){._3Wcfe{display:none}}._1TCyT{font-size:26px;font-size:1.625rem;letter-spacing:4.48px;letter-spacing:.28rem}._1TCyT,.fp7X4{font-weight:700;line-height:32px;line-height:2rem}.fp7X4{font-size:24px;font-size:1.5rem;text-transform:uppercase}", ""]);

// exports
exports.locals = {
	"root": "O9oW9",
	"container": "qQ2mF",
	"drawer": "_1pDKW",
	"navigation": "_3U7Ez",
	"column": "_24MvK",
	"columnSpan35": "YbXHq",
	"flex": "_1kxfm",
	"link": "_3qu-v",
	"title": "_3Wcfe",
	"titleCn": "_1TCyT",
	"titleEn": "fp7X4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Header/Header.css
// module id = 641
// module chunks = 0 1 2 3 4 5